import React from "react";

interface IParams {
  isFullscreen: boolean;
  onZoomButtonClick: React.MouseEventHandler<HTMLButtonElement>;
}

const CustomFullscreenButton: React.FC<IParams> = ({
  isFullscreen,
  onZoomButtonClick,
}) => {
  
  return (
    <>
      <button
        type="button"
        className={`image-gallery-fullscreen-button${
          isFullscreen ? "active" : ""
        }`}
        onClick={onZoomButtonClick}
      >
        {isFullscreen ? (
          <i className="fas fa-compress fa-2x customIconBorder"></i>
        ) : (
          <i className="fas fa-expand fa-2x customIconBorder"></i>
        )}
      </button>
    </>
  );
};

export default CustomFullscreenButton;
